<div class="row">
  <div class="col-sm-10">
    <div class="row no-gutters">
      <mat-form-field class="full-width">
        <mat-label>Text one-line</mat-label>
        <input type="text" matInput
               [(ngModel)]="some"
        >
      </mat-form-field>
    </div>
  </div>
  <div class="col-sm-2">
    <!-- PLACEHOLDER FOR ACTION BUTTONS-->
  </div>
</div>
